import { useTheme as n, useMediaQuery as i, alpha as a, popoverClasses as u, menuClasses as m, listClasses as g, svgIconClasses as c, paperClasses as l, radioClasses as b, alertClasses as s, chipClasses as t, inputBaseClasses as p, inputAdornmentClasses as y, typographyClasses as h, buttonClasses as M } from "@mui/material";
import { mainTheme as d, getMainTheme as v, Themes as k } from "@ankr.com/ui";
import O from "@mui/material/styles/zIndex";
import x from "deepmerge";
const C = () => {
  const { breakpoints: r } = n();
  return i(r.down("xs"));
}, B = () => {
  const { breakpoints: r } = n();
  return i(r.down("sm"));
}, A = () => {
  const { breakpoints: r } = n();
  return i(r.down("md"));
}, T = () => {
  const { breakpoints: r } = n();
  return i(r.down("lg"));
}, D = () => {
  const { breakpoints: r } = n();
  return i(r.up("sm"));
}, R = () => {
  const { breakpoints: r } = n();
  return i(r.up("md"));
}, P = () => {
  const { breakpoints: r } = n();
  return i(r.up("lg"));
}, z = () => {
  const { breakpoints: r } = n();
  return i(r.up("xl"));
}, F = () => {
  const { breakpoints: r } = n();
  return i(r.down("xl"));
}, W = (r) => {
  const { breakpoints: o } = n();
  return i(o.down(r));
}, H = () => {
  const {
    palette: { mode: r }
  } = n();
  return r;
}, $ = 375, L = 72, E = 220, U = ({
  palette: r
} = {}) => {
  const o = r ? x(d.palette, r) : d.palette, e = v(k[o.mode]);
  return {
    ...e,
    spacing: e.spacing,
    palette: o,
    breakpoints: e.breakpoints,
    components: {
      ...e.components,
      MuiCssBaseline: {
        ...e.components?.MuiCssBaseline,
        styleOverrides: {
          "html, body, #root": {
            minWidth: $,
            minHeight: "100vh"
          },
          html: {
            overflowX: "hidden",
            overflowY: "scroll",
            scrollBehavior: "smooth"
          },
          body: {
            position: "relative",
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            boxSizing: "border-box",
            fontSize: 16,
            lineHeight: 1.2,
            margin: 0,
            padding: 0,
            textRendering: "optimizeLegibility",
            backgroundColor: o.background.default,
            color: o.text.primary,
            fontFeatureSettings: "'cv11' on, 'case' on, 'calt' off"
          },
          a: {
            color: o.link.main,
            fontSize: "inherit",
            textDecoration: "none",
            transition: `color ${e.transitions.duration.short}ms`
          },
          hr: {
            width: "100%",
            borderWidth: "1px 0 0",
            borderStyle: "solid",
            borderColor: o.divider
          },
          "button, input, optgroup, select, textarea": {
            fontFamily: "inherit",
            fontSize: "100%",
            lineHeight: 1.1,
            margin: 0
          },
          "::-moz-focus-inner": { borderStyle: "none", padding: 0 },
          "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0
          },
          "input[type=number]": {
            MozAppearance: "textfield"
          },
          "strong, b": {
            fontWeight: 700
          },
          ".nowrap": {
            whiteSpace: "nowrap"
          },
          label: {
            cursor: "pointer"
          },
          "::selection": {
            backgroundColor: o.primary.main,
            color: o.primary.contrastText,
            textShadow: "none",
            WebkitTextFillColor: o.primary.contrastText
          },
          "::-webkit-scrollbar": {
            width: 10,
            height: 10
          },
          "::-webkit-scrollbar-corner": {
            background: "transparent"
          },
          "::-webkit-scrollbar-track": {
            background: "transparent",
            margin: 1,
            borderRadius: 10,
            "&:hover": {
              background: a(o.grey[500], 0.5)
            }
          },
          "::-webkit-scrollbar-thumb": {
            background: a(o.grey[700], 0.5),
            borderRadius: 10,
            transition: `background-color ${e.transitions.duration.short}ms`,
            "&:hover": {
              background: a(o.grey[700], 0.7)
            }
          }
        }
      },
      MuiTypography: {
        ...e.components?.MuiTypography,
        styleOverrides: {
          ...e.components?.MuiTypography?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiTypography?.styleOverrides?.root,
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontFeatureSettings: "'cv11' on, 'case' on, 'calt' off"
          }
        }
      },
      MuiBackdrop: {
        ...e.components?.MuiBackdrop,
        styleOverrides: {
          ...e.components?.MuiBackdrop?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiBackdrop?.styleOverrides?.root,
            backdropFilter: "blur(16px)"
          },
          invisible: {
            backdropFilter: "none"
          }
        }
      },
      MuiDialog: {
        ...e.components?.MuiDialog,
        styleOverrides: {
          ...e.components?.MuiDialog?.styleOverrides,
          paper: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiDialog?.styleOverrides?.paper,
            backgroundColor: o.background.paper,
            backgroundImage: "none",
            margin: e.spacing(5)
          }
        }
      },
      MuiDrawer: {
        ...e.components?.MuiDrawer,
        styleOverrides: {
          ...e.components?.MuiDrawer?.styleOverrides,
          paper: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiDrawer?.styleOverrides?.paper,
            backgroundColor: o.background.paper,
            backgroundImage: "none"
          }
        }
      },
      MuiContainer: {
        ...e.components?.MuiContainer,
        styleOverrides: {
          ...e.components?.MuiContainer?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiContainer?.styleOverrides?.root,
            [e.breakpoints.only("xl")]: {
              maxWidth: 1374,
              paddingLeft: e.spacing(7.5),
              paddingRight: e.spacing(7.5)
            },
            [e.breakpoints.down("xl")]: {
              maxWidth: 1060,
              paddingLeft: e.spacing(7.5),
              paddingRight: e.spacing(7.5)
            },
            [e.breakpoints.down("sm")]: {
              paddingLeft: e.spacing(4),
              paddingRight: e.spacing(4)
            }
          }
        }
      },
      MuiButtonBase: {
        defaultProps: {
          ...e.components?.MuiButtonBase?.defaultProps,
          disableRipple: !0
        },
        ...e.components?.MuiButtonBase,
        styleOverrides: {
          ...e.components?.MuiButtonBase?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiButtonBase?.styleOverrides?.root,
            height: "auto"
          }
        }
      },
      MuiButton: {
        ...e.components?.MuiButton,
        styleOverrides: {
          ...e.components?.MuiButton?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiButton?.styleOverrides?.root,
            verticalAlign: "baseline"
          },
          outlined: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiButton?.styleOverrides?.outlined,
            border: 0,
            [`&.${M.colorPrimary}`]: {
              boxShadow: `0 0 0 2px ${o.divider}`,
              "&:hover": {
                backgroundColor: "transparent"
              }
            }
          },
          text: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiButton?.styleOverrides?.text,
            "&:hover": {
              backgroundColor: "transparent"
            }
          }
        }
      },
      MuiIconButton: {
        ...e.components?.MuiIconButton,
        styleOverrides: {
          ...e.components?.MuiIconButton?.styleOverrides,
          colorInherit: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiIconButton?.styleOverrides?.colorInherit,
            borderColor: o.divider,
            color: o.divider,
            "&:hover": {
              backgroundColor: "transparent",
              borderColor: o.grey[400]
            }
          }
        }
      },
      MuiInputBase: {
        ...e.components?.MuiInputBase,
        styleOverrides: {
          ...e.components?.MuiInputBase?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiInputBase?.styleOverrides?.root,
            height: "auto",
            minHeight: 48,
            "&&": {
              backgroundColor: o.background.default,
              "&:hover": {
                backgroundColor: o.background.default
              }
            },
            [`&.${p.multiline}`]: {
              height: "auto",
              minHeight: 48,
              paddingTop: e.spacing(2)
            },
            [`&&.${p.focused}`]: {
              boxShadow: `0 0 0 2px ${o.primary.main}`
            },
            [`&&.${p.error}`]: {
              boxShadow: `0 0 0 2px ${o.error.main}`,
              color: o.error.main
            }
          }
        }
      },
      MuiFormLabel: {
        ...e.components?.MuiFormLabel,
        styleOverrides: {
          ...e.components?.MuiFormLabel?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiFormLabel?.styleOverrides?.root,
            [`& .${h.root}`]: {
              color: o.text.primary
            }
          }
        }
      },
      MuiTextField: {
        ...e.components?.MuiTextField,
        defaultProps: {
          ...e.components?.MuiTextField?.defaultProps,
          variant: "filled"
        }
      },
      MuiInputAdornment: {
        ...e.components?.MuiInputAdornment,
        styleOverrides: {
          ...e.components?.MuiInputAdornment?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiInputAdornment?.styleOverrides?.root,
            "& > img": {
              width: 24,
              height: 24
            },
            [`&.${y.sizeSmall} > img`]: {
              width: 16,
              height: 16
            }
          }
        }
      },
      MuiSelect: {
        ...e.components?.MuiSelect,
        styleOverrides: {
          ...e.components?.MuiSelect?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiSelect?.styleOverrides?.root,
            [`&.${p.sizeSmall}`]: {
              height: "auto",
              minHeight: 28,
              borderRadius: 10
            }
          },
          select: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiSelect?.styleOverrides?.select,
            color: o.text.primary,
            fontWeight: 400
          },
          icon: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiSelect?.styleOverrides?.icon,
            color: o.text.secondary
          }
        }
      },
      MuiAutocomplete: {
        ...e.components?.MuiAutocomplete,
        styleOverrides: {
          ...e.components?.MuiAutocomplete?.styleOverrides,
          endAdornment: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiAutocomplete?.styleOverrides?.endAdornment,
            right: e.spacing(1),
            top: `calc(50% - ${e.spacing(5)})`,
            [`& .${c.root}`]: {
              fill: o.grey[400]
            }
          },
          inputRoot: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiAutocomplete?.styleOverrides?.inputRoot,
            [`&.${p.root}`]: {
              height: "auto",
              minHeight: 48,
              paddingTop: e.spacing(0.5)
            }
          }
        }
      },
      MuiSvgIcon: {
        ...e.components?.MuiSvgIcon,
        styleOverrides: {
          ...e.components?.MuiSvgIcon?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiSvgIcon?.styleOverrides?.root,
            [`&.${t.deleteIcon}`]: {
              fill: o.grey[400]
            }
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          ...e.components?.MuiChip?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiChip?.styleOverrides?.root,
            "&:active": {
              boxShadow: "none"
            },
            [`&&:has(.${t.icon})`]: {
              gap: e.spacing(1),
              paddingTop: e.spacing(0.5),
              paddingBottom: e.spacing(0.5)
            },
            [`&.${t.sizeMedium}`]: {
              height: "auto",
              minHeight: 30,
              padding: e.spacing(0, 3),
              borderRadius: 8,
              [`& .${t.label}`]: {
                fontSize: 16,
                fontWeight: 500
              }
            },
            [`&.${t.sizeSmall}`]: {
              borderRadius: 8,
              height: "auto",
              minHeight: 20,
              padding: e.spacing(0, 2),
              [`& .${t.label}`]: {
                fontSize: 12,
                fontWeight: 500
              }
            },
            [`&.${t.colorSecondary}`]: {
              "&&": {
                backgroundColor: o.grey[100],
                [`& .${t.label}`]: {
                  color: o.text.secondary
                }
              }
            },
            [`&.${t.colorPrimary}`]: {
              "&&": {
                backgroundColor: o.primary.light,
                [`& .${t.label}`]: {
                  color: o.primary.main
                }
              }
            },
            [`&.${t.colorSuccess}`]: {
              "&&": {
                backgroundColor: o.success.light,
                [`& .${t.label}, & .${t.icon}`]: {
                  color: o.success.main
                }
              }
            },
            [`&.${t.colorError}`]: {
              "&&": {
                backgroundColor: o.error.light,
                [`& .${t.label}, & .${t.icon}`]: {
                  color: o.error.main
                }
              }
            }
          },
          label: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiChip?.styleOverrides?.label,
            flexShrink: 1,
            flexBasis: "fit-content",
            whiteSpace: "normal",
            textAlign: "center",
            wordBreak: "normal",
            padding: 0
          },
          icon: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiChip?.styleOverrides?.icon,
            flexShrink: 1,
            margin: 0
          }
        }
      },
      MuiAlert: {
        ...e.components?.MuiAlert,
        styleOverrides: {
          ...e.components?.MuiAlert?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiAlert?.styleOverrides?.root,
            [`&.${s.colorInfo}`]: {
              "&&": {
                backgroundColor: o.info.light,
                [`& .${s.message}, & .${s.icon}`]: {
                  color: o.info.main
                }
              }
            },
            [`&.${s.colorSuccess}`]: {
              "&&": {
                backgroundColor: o.success.light,
                [`& .${s.message}, & .${s.icon}`]: {
                  color: o.success.main
                }
              }
            },
            [`&.${s.colorError}`]: {
              "&&": {
                backgroundColor: o.error.light,
                [`& .${s.icon}`]: {
                  color: o.error.main
                }
              }
            },
            [`&>.${s.icon}>.${c.root}`]: {
              color: "inherit"
            }
          }
        }
      },
      MuiRadio: {
        ...e.components?.MuiRadio,
        styleOverrides: {
          ...e.components?.MuiRadio?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiRadio?.styleOverrides?.root,
            "--radio-background": o.background.paper,
            "--radio-border": o.text.secondary,
            "--radio-checked": "unset",
            [`&.${b.checked}`]: {
              "--radio-background": o.primary.main,
              "--radio-border": o.primary.main,
              "--radio-checked": o.background.paper
            }
          }
        }
      },
      MuiPopper: {
        ...e.components?.MuiPopper,
        styleOverrides: {
          ...e.components?.MuiPopper?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiPopper?.styleOverrides?.root,
            zIndex: O.drawer
          }
        }
      },
      MuiPaper: {
        ...e.components?.MuiPaper,
        defaultProps: {
          ...e.components?.MuiPaper?.defaultProps,
          elevation: 0
        },
        styleOverrides: {
          ...e.components?.MuiPaper?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiPaper?.styleOverrides?.root,
            padding: e.spacing(1),
            backgroundImage: "none",
            [`&.${l.rounded}`]: {
              borderRadius: 16
            },
            [`&.${l.elevation1}`]: {
              boxShadow: `0px 1px 5px 0px ${a(e.palette.text.primary, 0.14)}, 0px 1px 8px 0px ${a(e.palette.text.primary, 0.12)}`
            }
          }
        }
      },
      MuiMenuItem: {
        ...e.components?.MuiMenuItem,
        defaultProps: {
          ...e.components?.MuiMenuItem?.defaultProps,
          disableRipple: !0
        },
        styleOverrides: {
          ...e.components?.MuiMenuItem?.styleOverrides,
          root: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...e.components?.MuiMenuItem?.styleOverrides?.root,
            padding: e.spacing(2),
            gap: e.spacing(2),
            borderRadius: 12,
            minWidth: 190,
            "&:hover": {
              backgroundColor: o.grey[100],
              [`${c.root}`]: {
                color: o.primary.main
              }
            },
            [`.${u.root}.${m.root} .${g.root} &`]: {
              maxWidth: 450,
              whiteSpace: "normal",
              wordBreak: "break-word"
            }
          }
        }
      }
    }
  };
};
export {
  L as HEADER_HEIGHT,
  $ as MIN_LAYOUT_WIDTH,
  E as SIDEBAR_WIDTH,
  U as getMainThemeOptions,
  W as useIsDown,
  T as useIsLGDown,
  P as useIsLGUp,
  A as useIsMDDown,
  R as useIsMDUp,
  B as useIsSMDown,
  D as useIsSMUp,
  F as useIsXLDown,
  z as useIsXLUp,
  C as useIsXSDown,
  H as useThemeMode
};
//# sourceMappingURL=index.js.map
